import { Reveal } from "@/lib/motion";

const WA_URL = "https://wa.me/4915225477425";

export default function WhatsAppCTA() {
  return (
    <section id="whatsapp" data-testid="whatsapp-section" className="border-b border-white/10">
      <Reveal>
        <div className="mx-auto flex max-w-6xl flex-col items-start gap-6 px-5 py-14 sm:flex-row sm:items-center sm:justify-between lg:px-8">
          <div className="max-w-xl">
            <p className="mb-2 text-xs uppercase tracking-[0.25em] text-[#22C55E]">WhatsApp-Business</p>
            <h3 className="font-display text-2xl font-semibold text-white">Fragen? Schreib uns einfach!</h3>
            <p className="mt-2 text-sm leading-relaxed text-white/60">
              Du hast Fragen zu FestivalPlan, Probleme mit der App oder möchtest uns Feedback geben?
              Schreib uns einfach direkt über WhatsApp.
            </p>
          </div>
          <a
            href={WA_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="home-whatsapp-btn"
            className="inline-flex shrink-0 items-center gap-2.5 rounded-full bg-[#22C55E] px-6 py-3 text-sm font-medium text-black transition-colors hover:bg-[#1eae4f]"
          >
            Per WhatsApp schreiben
          </a>
        </div>
      </Reveal>
    </section>
  );
}
